// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const fixed = "Annotation__fixed__xSgIX";
export const responsive = "Annotation__responsive__S5ciL";
export const moduleClass = "Annotation__moduleClass__K9inx";
export const annotation = "Annotation__annotation__4Ug-K";
export const blue = "Annotation__blue__FOlav";
export const expanded = "Annotation__expanded__yPRjf";
export const moduleInsight = "Annotation__moduleInsight__Ke3kX";
export const header = "Annotation__header__0L57q";
export const postMode = "Annotation__postMode__yF9KP";
export const closeButton = "Annotation__closeButton__Wlyk2";
export const content = "Annotation__content__946oF";
export const text = "Annotation__text__xIxxs Text__bodyText__20Sxx font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const title = "Annotation__title__uZwaw";
export const golden = "Annotation__golden__uRVGa";